"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Box_1 = require("@material-ui/core/Box");
var react_intl_1 = require("react-intl");
var core_1 = require("@material-ui/core");
var customRadioGroupStyles_1 = require("./customRadioGroupStyles");
var constants_1 = require("../../../../../../../common/constants/constants");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var ShowIfTranslationExists_1 = require("../../../../../common/components/ShowIfTranslationExists");
exports.CustomRadioGroup = function (_a) {
    var formData = _a.formData;
    var styles = customRadioGroupStyles_1.default();
    var value = formData.value, id = formData.id, label = formData.label, onChange = formData.onChange, enumOptions = formData.options.enumOptions, rawErrors = formData.rawErrors, schema = formData.schema;
    var showOnlyLegalDisclaimerMandatoryLegend = core_1.useTheme().checkoutLite.enquiryForm.showOnlyLegalDisclaimerMandatoryLegend;
    var _b = react_1.useState(value), selectedValue = _b[0], setSelectedValue = _b[1];
    var intl = react_intl_1.useIntl();
    var handleChange = react_1.useCallback(function (e) {
        setSelectedValue(e.target.value);
        onChange(e.target.value);
    }, []);
    return (<Box_1.default className={styles.container}>
      {showOnlyLegalDisclaimerMandatoryLegend && (<ShowIfTranslationExists_1.default translationKey={'trans__checkout__enquiry_form__mandatory_legend'}>
          <>
            <Box_1.default className={styles.mandatoryLegend}>
              <core_1.Typography data-test={"mandatory:label:" + id}>
                {intl.formatMessage({ id: 'trans__checkout__enquiry_form__mandatory_legend' })}
              </core_1.Typography>
            </Box_1.default>
          </>
        </ShowIfTranslationExists_1.default>)}
      <core_1.Typography className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: label }} onClick={function (e) {
        if (!e.target.hasAttribute('href')) {
            e.preventDefault();
        }
    }} data-test={"text:enquiryForm:" + id}/>
      <Box_1.default className={styles.errorMessageContainer}>
        {value === constants_1.constants.NO && (<core_1.Typography className={styles.errorMessage}>
            <Translation_1.default id="trans__checkout__enquiry_form__authorize__must_select_yes"/>
          </core_1.Typography>)}
      </Box_1.default>
      <core_1.RadioGroup className={styles.radioButtonGroup}>
        {enumOptions.map(function (option, index) {
        var _a;
        return (<Box_1.default className={styles.radioButtonContainer} key={index}>
            <core_1.Radio color={'primary'} id={id} checked={selectedValue === option.value} value={option.value} size={'medium'} onChange={handleChange} data-test={"radioButton:" + option.value} name={option.value} classes={{
            root: styles.root,
        }}/>
            <Box_1.default className={styles.labelContainer}>
              <core_1.Typography variant={'body2'} data-test={"text:enquiryForm:" + option.value}>
                {option.label}
              </core_1.Typography>
              {((_a = schema) === null || _a === void 0 ? void 0 : _a.disclaimers) && (<core_1.Typography className={styles.disclaimer} data-test={"text:enquiryForm:" + option.value + ":disclaimer"}>
                  {schema.disclaimers[option.value]}
                </core_1.Typography>)}
              <core_1.Typography className={styles.errorMessage}>{rawErrors && rawErrors[index]} </core_1.Typography>
            </Box_1.default>
          </Box_1.default>);
    })}
      </core_1.RadioGroup>
    </Box_1.default>);
};
exports.default = exports.CustomRadioGroup;
